import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

export default function UnixTime(props) {
  const {format, value} = props;
  return <>{value === undefined || value === null ? '' : moment.unix(value).format(format)}</>;
}

UnixTime.defaultProps = {
  format: 'll LTS',
};

UnixTime.propTypes = {
  /** DateTime format to convert to. */
  format: PropTypes.string,
  /** Unix time to render. */
  value: PropTypes.number,
};
